"use client";
import React from "react";
import { MdCancel } from "react-icons/md";
import AddFieldLogic from "./AddFieldLogic";
import "./AddField.css";
import { FaPlus, FaTimes } from "react-icons/fa";
import { IoChevronDown } from "react-icons/io5";
export default function AddField({ onCancel, onSave, editData }) {
  const {
    formData,
    dictionaryList,
    handleChange,
    handleSubmit,
    addOption,
    updateOption,
    removeOption,
    errors,
    allowManualOptions,
    handleValueSeparatorChange,
    handleVisibilityChange
  } = AddFieldLogic({ onCancel, onSave, editData });
  return (
    <div className="AF-modal">
      <div className="AF-body">

        <div className="AF-header">
          <span>{editData ? "Edit Field" : "Add Field"}</span>
          <MdCancel size={24} className="AF-closeBtn" onClick={onCancel} />
        </div>

        <div className="AF-bodyMain">
          <form onSubmit={handleSubmit}>
            <div className="AF-fields">

              {/* Field Name */}
              <div className="form-group AF-inputsSet input-text-enter">
                <label>Field Name<span style={{ color: "#dc3545" }}> *</span></label>
                <input
                  type="text"
                  name="field_name"
                  value={formData.field_name}
                  onChange={handleChange}
                  className={`form-control  ${errors.field_name ? "input-addfield-error" : ""}`}
                  placeholder="e.g., pg_case_number"
                />
                {errors.field_name && <span className="error-addfield">{errors.field_name}</span>}

              </div>

              {/* Data Type */}
              <div className="AF-inputsSet input-text-enter">
                <label>Data Type<span style={{ color: "#dc3545" }}> *</span></label>
                <div className="AF-selectWrapper">
                  <select
                    name="data_type"
                    className={`form-control AF-select ${errors.data_type ? "input-addfield-error" : ""}`}
                    value={formData.data_type}
                    onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="string">string</option>
                    <option value="number">number</option>
                    <option value="date">date</option>
                    <option value="group">group</option>
                    <option value="list">list</option>
                    <option value="bool">bool</option>
                  </select>
                  <IoChevronDown className="AF-dropdownIcon" />
                </div>
                {errors.data_type && <span className="error-addfield">{errors.data_type}</span>}
              </div>

              {/* UI Type */}
              <div className="AF-inputsSet">
                <label>UI Type<span style={{ color: "#dc3545" }}> *</span></label>
                <div className="AF-selectWrapper">
                  <select
                    name="ui_type"
                    className={`form-control AF-select ${errors.ui_type ? "input-addfield-error" : ""}`}
                    value={formData.ui_type}
                    onChange={handleChange}>
                    <option value="">Select</option>
                    {formData.data_type === "string" && (
                      <>
                        <option value="textbox">textbox</option>
                        <option value="textarea">textarea</option>
                        <option value="dropdown">dropdown</option>
                        <option value="checkbox">checkbox</option>
                      </>
                    )}
                    {formData.data_type === "number" && (
                      <>
                        <option value="textbox">textbox</option>
                        <option value="dropdown">dropdown</option>
                        <option value="checkbox">checkbox</option>
                      </>
                    )}
                    {/* GROUP */}
                    {formData.data_type === "group" && (
                      <>
                        <option value="multiparttextfield">multiparttextfield</option>
                        <option value="inline">inline</option>
                      </>
                    )}

                    {formData.data_type === "date" && (
                      <option value="textbox">textbox</option>
                    )}

                    {/* LIST */}
                    {formData.data_type === "list" && (
                      <option value="inline">inline</option>
                    )}

                    {/* BOOL */}
                    {formData.data_type === "bool" && (
                      <option value="checkbox">checkbox</option>
                    )}

                  </select>
                  <IoChevronDown className="AF-dropdownIcon" />
                </div>
                {errors.ui_type && <span className="error-addfield">{errors.ui_type}</span>}

              </div>

              {/* Label */}
              <div className="AF-inputsSet input-text-enter">
                <label>Label<span style={{ color: "#dc3545" }}> *</span></label>
                <input
                  type="text"
                  name="label"
                  value={formData.label}
                  onChange={handleChange}
                  className={`form-control  ${errors.label ? "input-addfield-error" : ""}`}
                  placeholder="e.g., PG Case No" />
                {errors.label && <span className="error-addfield">{errors.label}</span>}
              </div>

              {/* Visibility */}
              <div className="AF-inputsSet input-text-enter">
                <label>Visibility<span style={{ color: "#dc3545" }}> *</span></label>
                <div className="AF-selectWrapper">
                  <select
                    name="visibility"
                    className={`form-control AF-select ${errors.visibility ? "input-addfield-error" : ""}`}
                    value={formData.visibility}
                    onChange={handleVisibilityChange}>
                    <option value="">Select</option>
                    <option value="editable">editable</option>
                    <option value="readonly">readonly</option>
                    <option value="hidden">hidden</option>
                  </select>
                  <IoChevronDown className="AF-dropdownIcon" />
                </div>
                {errors.visibility && <span className="error-addfield">{errors.visibility}</span>}
              </div>

              {/* Source */}
              <div className="AF-inputsSet input-text-enter">
                <label>Source<span style={{ color: "#dc3545" }}> *</span></label>
                <div className="AF-selectWrapper">
                  <select
                    name="source"
                    className={`form-control AF-select ${errors.source ? "input-addfield-error" : ""}`}
                    value={formData.source}
                    disabled={formData.visibility === "hidden" || formData.visibility === "readonly"}
                    onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="system">system</option>
                    <option value="user">user</option>
                  </select>
                  <IoChevronDown className="AF-dropdownIcon" />
                </div>
                {errors.source && <span className="error-addfield">{errors.source}</span>}
              </div>


              {/* Value Separator */}
              <div className="AF-inputsSet">
                <label>Value Separator
                  {formData.ui_type === "multiparttextfield" && (
                    <span style={{ color: "#dc3545" }}> *</span>
                  )}</label>
                <input
                  type="text"
                  name="value_separator"
                  value={formData.value_separator}
                  onChange={handleValueSeparatorChange}
                  className={`form-control  ${formData.ui_type !== "multiparttextfield" ? "readonly-input" : ""}
                    ${errors.value_separator ? "input-addfield-error" : ""}`}
                  placeholder="e.g., - (for multipart fields)"
                  readOnly={formData.ui_type !== "multiparttextfield"} />
                {errors.value_separator && <span className="error-addfield">{errors.value_separator}</span>}
              </div>

              <div className="form-group AF-inputsSet input-text-enter">
                <label>Help Text
                  {(formData.data_type === "group" || formData.data_type === "list") && (
                    <span style={{ color: "#dc3545" }}> *</span>
                  )}
                </label>
                <input
                  type="text"
                  name="help_text"
                  value={formData.help_text}
                  onChange={handleChange}
                  className={`form-control ${errors.help_text ? "input-addfield-error" : ""}`}
                  placeholder="Enter Help Text" />
                {errors.help_text && <span className="error-addfield">{errors.help_text}</span>}
              </div>

              {/* Dictionary ID Dropdown */}
              {formData.ui_type === "dropdown" && (
                <>
                  <div className="AF-inputsSet input-text-enter">
                    <label>Dictionary ID</label>
                    <div className="AF-selectWrapper">
                      <select
                        name="ck_dictionary_id"
                        className="form-control AF-select"
                        value={formData.ck_dictionary_id}
                        onChange={handleChange}>
                        <option value="">Select Dictionary</option>
                        {dictionaryList.map((item, index) => (
                          <option key={index} value={item.ck_dictionary_id}>
                            {item.display_text}
                          </option>
                        ))}
                      </select>
                      <IoChevronDown className="AF-dropdownIcon" />
                    </div>
                  </div>

                  {/* OPTIONS */}
                  <div className="AF-inputsSet1 input-text-enter">
                    <label>
                      Options
                      {!allowManualOptions && (
                        <span style={{ fontSize: "12px", color: "#888", marginLeft: "6px" }}>
                          (Manual entry allowed only for Dropdown)
                        </span>
                      )}
                    </label>
                    <div className="AF-optionsScroll">
                      {formData.options.map((opt, index) => (
                        <div key={index} className="AF-optionRow">

                          <input
                            type="text"
                            className={`form-control AF-input ${!allowManualOptions ? "readonly-input" : ""
                              }`}
                            placeholder="Text"
                            value={opt.text || ""}
                            readOnly={!allowManualOptions}
                            onChange={(e) =>
                              allowManualOptions &&
                              updateOption(index, "text", e.target.value)
                            } />

                          <input
                            type="text"
                            className={`form-control AF-input ${!allowManualOptions ? "readonly-input" : ""
                              }`}
                            placeholder="Value"
                            value={opt.value || ""}
                            readOnly={!allowManualOptions}
                            onChange={(e) =>
                              allowManualOptions &&
                              updateOption(index, "value", e.target.value)
                            } />
                          <div className="Remove-edit">
                            {allowManualOptions && (
                              <FaTimes
                                className="AF-icon remove-icon"
                                onClick={() => removeOption(index)}
                              />
                            )}

                            {allowManualOptions && index === formData.options.length - 1 && (
                              <FaPlus className="AF-icon add-icon" onClick={addOption} />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="AF-btnRight">
              <button type="submit" className="AF-saveBtn">
                {editData ? "Update Field" : "Save Field"}
              </button>
            </div>
          </form>
        </div>
      </div >
    </div >
  );
}
